import { render } from "./RideMaster2.vue?vue&type=template&id=be025e2a&scoped=true"
import script from "./RideMaster2.vue?vue&type=script&lang=js"
export * from "./RideMaster2.vue?vue&type=script&lang=js"

import "./RideMaster2.vue?vue&type=style&index=0&id=be025e2a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be025e2a"]])

export default __exports__